import useSWR from "swr";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createSearchRegionsUrl } from "@is/services";

type Params = {
  countryCode: string;
  zipCode: string;
};

type Region = {
  id: string;
  countryCode: string;
  zipCode: string;
  city: string;
  region: string;
  subRegion: string;
};

export const useSearchRegions = (params: Params) => {
  const { setApiHeaders } = useManageApiHeaders();

  const { zipCode } = params;

  setApiHeaders();

  const url = createSearchRegionsUrl(params);

  const shouldSearch = zipCode.length > 2;

  const { data, error, isLoading } = useSWR(shouldSearch && url, api.get);

  return {
    regions: (data as Region[]) || null,
    isLoading,
    error,
  };
};
